import z from 'zod';

export const primitive = z.union([z.string(), z.number(), z.boolean(), z.date()]);

export const productEntityFields = {
  productId: z.string(),
  sku: z.string(),
  category: z.string(),
  name: z.string(),
  brand: z.string(),
  variant: z.string(),
  price: z.number(),
  quantity: z.number(),
  coupon: z.string().optional(),
  position: z.number().optional(),
  url: z.string().optional(),
  imageUrl: z.string().url().optional(),
  currency: z.string(),
  ean: z.string().optional(),
  isbn: z.string().optional(),
  edition: z.string().optional(),
  productType: z.string().optional(),
  opco: z.string().optional(),
  segment: z.string().optional(),
  subject: z.string().optional(),
  domain: z.string().optional(),
  method: z.string().optional(),
  educationLevel: z.string().optional(),
  stream: z.string().optional(),
  yearGroup: z.string().optional(),
  title: z.string().optional(),
};
